/*
  Checkable
 */

var Checkable = (function ($) {
  var m = (function () {
    var name = 'Checkable';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      update: function ($input) {
        var $element = $input.closest('.js-checkable');
        var name = $input.attr('name');
        var type = $input.attr('type');
        var $others = $('input[name="' + name + '"]').not($input).closest('.js-checkable');

        // $input is a radio
        if (type === 'radio') {
          if ($input.is(':checked')) {
            $others.removeClass('is-checked');
            $element.addClass('is-checked');
          }
        }
        // $input is a checkbox
        else if (type === 'checkbox') {
          if ($input.is(':checked')) {
            $element.addClass('is-checked');
          }
          else {
            $element.removeClass('is-checked');
          }
        }
      }
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [

    ];

    /*
      Events
    */
    var events = {
      onChange: function () {
        $(document).on('change', '.js-checkable input', function () {
          handlers.update($(this));
        });
      },
      pageLoad: function () {
        $('.js-checkable input').each(function () {
          handlers.update($(this));
        });
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  try {
    m._init_();
  }
  catch (e) {
    console.error('Module failed to initialize: ' + m);
    console.error(e);
  }

  return m;
}(jQuery));
